import { produce } from 'immer';

import { generateQueryString } from '../utils/BroadbandQueryString';

export const search = (searchUrl, criteria, coveragePromise) => {
    if (!coveragePromise) {
        const criteriaForUrl = produce(criteria, draft => {
            if (draft.connectionTypes?.isAll) {
                delete draft.connectionTypes;
            }
        });
        goToSearchPage(searchUrl, criteriaForUrl);
        return;
    }

    coveragePromise
        .then(result => {
            if (!result) {
                goToSearchPage(searchUrl, criteria);
                return;
            }

            const defaultShortUrls = (result.connectionTypes || [])
                .map(t => t.shortUrl)
                .slice()
                .sort();

            const connectionTypeShortUrls =
                defaultShortUrls.length > 0
                    ? defaultShortUrls
                    : (criteria.connectionTypes?.values || []).slice().sort();

            const newCriteria = produce(criteria, draft => {
                draft.connectionTypes = { values: connectionTypeShortUrls };
                if (!result.useDefaultSuppliers) {
                    draft.common.suppliers = {};
                }
            });
            goToSearchPage(searchUrl, newCriteria);
        })
        .catch(() => goToSearchPage(searchUrl, criteria));
};

export const goToSearchPage = (searchUrl, criteria) => {
    const url = searchUrl;
    const queryString = generateQueryString(criteria, null, false);
    const fullUrl = queryString.length ? `${url}?${queryString}` : url;
    location.href = fullUrl;
};

export default class BroadbandHomeActions {
    search;
    goToSearchPage;
}
